module.exports = __webpack_public_path__ + "img/Qionghai_Dai@2x.06b6f2b7.png";